import { Link } from 'react-router-dom';
import { useMeContext } from '../api/me-provider.js';
import { SwingReplayName } from '../components/swing-replay-name.js';

/**
 * Tools (ruled 16 October): a menu of links to other things an athlete uses
 * with their coach. Athlete Portal canvas, "Noa · Tools"; parents have it too
 * (board R6, ruled 1 November), going through who is practicing.
 *
 * SWINGREPLAY is its first row (stage 4; mockup board 7, approved 25 October):
 * opened here it has no lesson, and leaving it makes a practice.
 */
export function ToolsRoute() {
  const { state } = useMeContext();
  const replay = state.status === 'athlete' ? '/tools/recul' : '/tools/who';
  return (
    <>
      <div className="page-head">
        <div>
          <h2>Tools</h2>
        </div>
      </div>
      <Link className="hour-row" to={replay}>
        <span className="hour-row-text">
          <span className="name">
            <SwingReplayName />
          </span>
        </span>
        <span className="chevron" aria-hidden="true">
          ›
        </span>
      </Link>
    </>
  );
}
